import { useEffect, useState } from "react";
import { Box, CardContent, CardHeader, Tooltip } from "@mui/material";
import { IconHelp, IconReceipt } from "@tabler/icons-react";
import { map } from "lodash";
import { useUsuario } from "../../../../providers/usuarioProvider";
import { Moment } from "moment";
import Transacao from "../../../../models/transacao";
import { onSnapshot, query, where } from "firebase/firestore";
import TransacaoDb from "../../../../db/transacaoDb";
import FelixCard from "../../../util/ui/felixCard";
import ChartContainer from "../../../util/charts/chartContainer";
import TabelaExtrato from "../../../util/tabelas/tabelaExtrato";

export default function Extrato({ mes }: { mes: Moment }) {
  const { visualizado } = useUsuario();
  const [transacoes, setTransacoes] = useState<Transacao[]>();

  useEffect(() => {
    if (!!visualizado && !!mes)
      return onSnapshot(
        query(
          new TransacaoDb().collection({
            usuarioId: visualizado,
            transacaoId: "",
          }),
          where("dataTransacao", ">=", mes.clone().startOf("month").toDate()),
          where(
            "dataTransacao",
            "<",
            mes.clone().add(1, "month").startOf("month").toDate()
          )
        ),
        (query) => {
          setTransacoes(map(query.docs, (snapshot) => snapshot.data()));
        }
      );
  }, [visualizado, mes]);

  return (
    <FelixCard>
      <CardHeader
        title="Extrato"
        avatar={<IconReceipt size={16} />}
        action={
          <Box display="flex" flexDirection="row" alignItems="center">
            <Tooltip title="Aqui estão as suas operações que tiveram algum resultado (lucro ou prejuízo).">
              <Box sx={{ color: "text.secondary" }}>
                <IconHelp size={16} />
              </Box>
            </Tooltip>
          </Box>
        }
      />
      <CardContent sx={{ maxHeight: 408 }}>
        <ChartContainer
          height={360}
          emptyText="Ainda não há extrado disponível para este mês."
          isEmpty={!transacoes}
          isLoading={false}
        >
          <TabelaExtrato transacoes={transacoes} maxWidth={408} />
        </ChartContainer>
      </CardContent>
    </FelixCard>
  );
}
